import { render, staticRenderFns } from "./SkipButton.vue?vue&type=template&id=15e247f2&scoped=true&"
import script from "./SkipButton.vue?vue&type=script&lang=js&"
export * from "./SkipButton.vue?vue&type=script&lang=js&"
import style0 from "./SkipButton.vue?vue&type=style&index=0&id=15e247f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e247f2",
  null
  
)

export default component.exports